import { FormOAuthModel } from '../../../../../shared/kiosk';
import { AbstractElementEditor } from './AbstractElementEditor';

export class OauthLoginEditor extends AbstractElementEditor<FormOAuthModel> {
  public getDescription(): string {
    return 'Login to external system';
  }

  public getName(): string {
    return 'Login to external system';
  }

  public getIcon(): string {
    return 'text_snippet';
  }
}
